import React from 'react';
import {Result} from 'antd';

export default function Forbidden() {
    return <Result status="403" style={{marginTop: 200, backgroundColor: 'transparent'}} />;
}
